module.exports = __webpack_public_path__ + "img/chat_unselected.70ab4895.svg";